export default __webpack_public_path__ + "static/inwestycje-61ae54ce815a282653c03057445c64db.webp";